import api from './api'

export interface PostalCodeResponse {
  estado: string
  ciudad: string
  municipio: string
  abreviatura: string
  colonias: string[]
  valid: boolean
  id_estado: number
}

class PostalCodeService {
  private cache: Map<string, PostalCodeResponse> = new Map()

  async searchByPostalCode(postalCode: string): Promise<PostalCodeResponse | null> {
    // Validate postal code format
    if (!/^\d{5}$/.test(postalCode)) {
      throw new Error('El código postal debe tener 5 dígitos')
    }

    // Check cache first
    if (this.cache.has(postalCode)) {
      return this.cache.get(postalCode)!
    }

    try {
      const response = await api.get('/postal-codes/search', {
        params: { d_codigo: postalCode }
      })

      console.log('Raw API response:', response.data)

      // The backend returns { success: true, data: {...} }
      const apiData = response.data
      
      if (apiData.success && apiData.data) {
        const postalData = apiData.data
        
        // Cache the result
        if (postalData.valid) {
          this.cache.set(postalCode, postalData)
        }
        
        return postalData
      }

      return null
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null
      }
      throw error
    }
  }

  // Clear cache if needed (e.g., on logout)
  clearCache(): void {
    this.cache.clear()
  }

  // Format state name to title case
  formatStateName(state: string): string {
    return state
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  // Format colony name to title case
  formatColonyName(colony: string): string {
    return colony
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  // Format city name to title case
  formatCityName(city: string): string {
    if (city === 'NO PROPORCIONADO') {
      return ''
    }
    return city
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
}

export default new PostalCodeService()